import { Component, ElementRef, Input } from '@angular/core';
import { TooltipOptions } from 'primeng/api';
import { map, take } from 'rxjs/operators';
import { CommandTemplate } from '../../shared/entities/commandTemplate/commandTemplate';
import { ApolloService } from '../../shared/services/apollo.service';
import { CommandService, Reloadable } from '../../shared/services/services/commandService/command.service';
import * as fromGraphQl from './graphql';

@Component({
  // tslint:disable-next-line:component-selector
  selector: "nx-command-button",
  templateUrl: "command-button.html",
  host: {
    'class': 'nx-command-button'
  },
  styleUrls: ["./command-button.scss"]
})
export class CommandButtonComponent {

  commandTemplate: CommandTemplate;

  tooltipOptions: TooltipOptions = {
    hideDelay: 150,
    showDelay: 300,
    tooltipEvent: 'hover',
    tooltipPosition: 'bottom'
  };

  _commandName: string;
  @Input() set commandName(commandName: string) {
    if(commandName !== undefined) {
      this._commandName = commandName;
      this.loadCommand();
    }
  };

  @Input() icon = "icon-plus";
  @Input() disabled: boolean = false;
  @Input() tooltip: string;
  @Input() tooltipPosition = "bottom";
  @Input() style: "light" | "transparent" | "dark" = "transparent";
  @Input() width: 'auto' | 'full' = 'auto';
  @Input() iconPos: "left" | "right" = "left";
  @Input() reloadable: Reloadable;

  constructor(
    private elRef: ElementRef,
    private apolloService: ApolloService,
    private commandService: CommandService
  ) {
  }


  loadCommand() {
    this.apolloService.query<fromGraphQl.CommandButtonQueryResponse>(
      fromGraphQl.COMMAND_BUTTON_QUERY,
      {
        commandName: this._commandName
      })
        .pipe(
          take(1),
          map(response => {
            if(response.data.getCommand){
              this.commandTemplate = new CommandTemplate(response.data.getCommand);
            }
          })
        ).subscribe();
  }  

  getNativeElement(): HTMLElement {
    return this.elRef.nativeElement;
  }

  getButtonClasses(): string {
    let classes = "";
    if(this.icon === undefined) {
      classes = "p-button-text-only";
    }
    if(this.icon !== undefined) {
      classes = "p-button-text-and-icon";
    }
    if(this.width === 'full') {
      classes += " p-button-full-width";
    }
    // icon only will be added from prime
    return classes;
  }

  getIconPosClass(): string {
    if(this.icon === undefined) {
      return undefined;
    }
    return this.iconPos;
  }

  getAdditionalClasses(): string {
    let additionalClasses = this.style;
    if(this.getIconPosClass() !== undefined) {
      additionalClasses += " icon-" + this.getIconPosClass();
    }
    return additionalClasses;
  }


  click($event) {
    // its a default button
    this.commandService.execute(undefined, this.commandTemplate, this.reloadable);
  }
}
